module.exports = __webpack_public_path__ + "img/banner-01.8d42de55.jpg";